
<div class="row col-md-12 padding-top-10 log_sch">
<form [formGroup]="resetPassword" (ngSubmit)="onPwdReset(resetPassword.value)" class="col-md-12">
    <div style="margin-bottom: 25px" class="input-group">
      <label>User ID</label>
      <input id="float-input" type="text" class="ui-inputtext form-control margin-left-10" formControlName="strUserId">
      <span class="input-group-addon"><i class="fa fa-user-o" aria-hidden="true"></i></span>
    </div>
    <div class="form-group sub_btn col-md-12">
        <div class="col-md-12 controls align-right">
          <button type="submit" class="btn btn-primary align-right">Reset Password</button>
        </div>

      </div>
</form>
</div> 